import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { eurekaApiUrlPrefix } from '@telecom/shared/domain-config';
import type {
    EurekaAllHistoryApi,
    EurekaAllHistoryResponse,
} from '../eureka-all-history-api';

/** Eureka 导航历史日期分组。 */
interface EurekaHistoryGroup {
    /** 当前日期分组内的历史记录。 */
    data?: unknown[];
}

/** Eureka 导航历史接口响应。 */
interface EurekaHistoryRecordsResponse {
    /** 按日期分组的历史记录。 */
    history_maps?: EurekaHistoryGroup[];
}

/** 基于 IP 导航历史接口的 Eureka 全部历史 API 实现。 */
@injectable()
export class EurekaAllHistoryApiImpl extends PsHttpService implements EurekaAllHistoryApi {
    get options() {
        return {
            baseURL: eurekaApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    /** 使用与 IP 导航一致的接口查询当前账号历史，并统计记录总数。 */
    async getAllHistory(): Promise<EurekaAllHistoryResponse> {
        const result = await this.get<PatSnapSuccessResponseData<EurekaHistoryRecordsResponse>>({
            url: '/history/records',
            params: {
                page: 1,
                pageSize: 100,
            },
        });
        const historyMaps = result.data?.history_maps ?? [];
        return {
            total: historyMaps.reduce((total, group) => total + (group.data?.length ?? 0), 0),
        };
    }
}
